import { LineItem } from '@/common/models';
import EntityPropertyUpdateHandler from '@/org-app/services/entityPropertyHandlers/EntityPropertyUpdateHandler';
import rootStore from '@/store';

const CADENCE_OPTIMIZED_IMPRESSIONS_KEY = 'cadence-optimized-impressions';

export function getLineItemCadenceOptimizedImpressions(lineItem: LineItem): number | null {
  const lineItemPropertyHandler = new EntityPropertyUpdateHandler(lineItem, rootStore);
  const value = lineItemPropertyHandler.getEntityProperty(CADENCE_OPTIMIZED_IMPRESSIONS_KEY)?.value;
  return value == null ? null : Number.parseFloat(value);
}

export function updateLineItemCadenceOptimizedImpressions(lineItem: LineItem, optimizedImpressions: number) {
  const lineItemPropertyHandler = new EntityPropertyUpdateHandler(lineItem, rootStore);
  return lineItemPropertyHandler.updateEntityProperty(
    CADENCE_OPTIMIZED_IMPRESSIONS_KEY,
    optimizedImpressions.toString(),
  );
}
